var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KImg',{style:({ height: '200px', width: '100%', maxWidth: '500px' }),attrs:{"altText":"A sitting hummingbird","scaleType":"centerInside","src":require('../common/hummingbird-small-cc-by-sa-4.jpg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }